import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';
import { retryConfig } from './retry.helper';

export const errorInterceptor: HttpInterceptorFn = errorInterceptorInternal;

function errorInterceptorInternal(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  return next(req).pipe(retry(retryConfig));
}
